import Button, {
  buttonVariants,
} from "@visiblethread/react-components/dist/components/Button";
import { useDispatch } from "react-redux";
import { downloadLogs } from "slices/systemAdmin/actions/authentication";

const DownloadLogs = () => {
  const dispatch = useDispatch();

  return (
    <div className="system_admin__download_logs" data-testid="download-logs">
      <span>Download Log Files</span>
      <Button
        onClick={() => {
          dispatch(downloadLogs());
        }}
        variant={buttonVariants.primary}
        content={<span>Download Log Files</span>}
        title="Files downloaded: catalina.out, vtdocs.log, error.log and hikari.log"
      />
    </div>
  );
};

export default DownloadLogs;
